import { Col, DesignTokens, FormItem, Input, PreviewSider, Row } from "melco-ui"
import styled from "styled-components";
import { useUploadHoopAsset } from "../../../hooks/hoops/useUploadHoopAsset";
import { useFormikContext } from "formik";
import { useState } from "react";
import { useUploadHoopPreviewAsset } from "../../../hooks/hoops/useUploadHoopPreviewAsset";

import { useTranslation } from "react-i18next";
export type HoopAssetTabProps = {
    hoop: any;
    setIsUploading: (b: boolean) => void;
}

const { spacings } = DesignTokens
const PreviewImage = styled.img`
max-width:50%
`

const StyledDivPaddingRight = styled.div`
 padding: 0  ${spacings.middle}px 0 0 ;
 `

const StyledDivPaddingLeft = styled.div`
 padding: 0 0 0 ${spacings.middle}
 `

export const HoopAssetTab: React.FC<HoopAssetTabProps> = ({ hoop, setIsUploading }) => {

    const { uploadHoopAsset } = useUploadHoopAsset(hoop?.cloud_id)
    const [assetFile, setAssetFile] = useState(hoop?.asset)
    const { setFieldValue } = useFormikContext();
    const { uploadHoopPreviewAsset } = useUploadHoopPreviewAsset(hoop?.cloud_id)
    const [previewAssetFile, setPreviewAssetFile] = useState(hoop?.preview_asset);
    const { t } = useTranslation();
    //let base64ImageString = Buffer.from(hoop?.asset, 'binary').toString('base64');
    return (
        <>
            <Row>
                <Col xs={24} md={12} xl={12}>
                    <Col xs={24} md={24} xl={24}>
                        <StyledDivPaddingRight>
                            <FormItem label={t("managehoops.tabs.asset.label.asset_file")}>
                                <Input
                                    name="file"
                                    type="file"

                                    onChange={async (e: any) => {
                                        try {
                                            setIsUploading(true);
                                            //  alert()
                                            let file = e.currentTarget.files[0];
                                            let response = await uploadHoopAsset(file);

                                            setFieldValue('asset', response?.asset);
                                            setAssetFile(response?.asset);
                                            console.log(typeof e.currentTarget.files[0]);

                                            setIsUploading(false)
                                        }
                                        catch (exp: any) {
                                            console.log("Exception occured in File upload ", (exp))
                                            setIsUploading(false)
                                        }
                                        finally {
                                            setIsUploading(false)
                                        }
                                    }}
                                />
                            </FormItem>
                        </StyledDivPaddingRight>
                    </Col>
                    <Col xs={24} md={24} xl={24}>

                        {hoop?.asset && <PreviewSider>

                            {hoop?.asset && <PreviewImage src={`data:image/svg+xml;utf8,${encodeURIComponent(assetFile)}`} />}
                        </PreviewSider>
                        }
                    </Col>
                </Col>

                <Col xs={24} md={12} xl={12}>
                    <Col xs={24} md={24} xl={24}>
                        <StyledDivPaddingLeft>
                            <FormItem label={t('managehoops.tabs.asset.label.preview_asset_file')}>
                                <Input
                                    name="file"
                                    type="file"

                                    onChange={async (e: any) => {
                                        try {
                                            setIsUploading(true)
                                            //  alert()
                                            let file = e.currentTarget.files[0];
                                            let response = await uploadHoopPreviewAsset(file);

                                            setFieldValue('preview_asset', response?.preview_asset);
                                            setPreviewAssetFile(response?.preview_asset);
                                            console.log(typeof e.currentTarget.files[0]);
                                            setIsUploading(false)
                                        }
                                        catch (exp: any) {
                                            console.log("Exception occured in File upload ", (exp))
                                            setIsUploading(false)
                                        }
                                        finally {
                                            setIsUploading(false)
                                        }
                                    }}
                                />
                            </FormItem>
                        </StyledDivPaddingLeft>
                    </Col>
                    <Col xs={24} md={24} xl={24}>

                        {hoop?.preview_asset && <PreviewSider>

                            {hoop?.preview_asset && <PreviewImage src={`data:image/svg+xml;utf8,${encodeURIComponent(previewAssetFile)}`} />}
                        </PreviewSider>
                        }
                    </Col>
                </Col>
            </Row>
        </>
    )
}